import React, { useEffect, useContext, useState, useRef } from 'react'

import { useNavigate } from 'react-router-dom';
import isEmail from "validator/lib/isEmail"

import {
  Box,
} from '@material-ui/core';

import { PlusCircle as PlusCircleIcon } from 'react-feather';
import { XCircle as XCircleIcon } from 'react-feather';

import APIS from "../../../../utils/APIS"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"


import { adminInputStyle } from "../adminStyles.js"

const AdminClientForm = ({ isEdit, adminClient, setHasChanged }) => {
  const navigate = useNavigate()

  const { ecoles, updateAdminAdminClients } = useContext(SuperAdminContext)

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [language, setLanguage] = useState("fr");
  const [suivi, setSuivi] = useState(true)
  const [mapping, setMapping] = useState(false)
  const [certif, setCertif] = useState(false)
  const [actEcoles, setActEcoles] = useState([])
  const [selectedEcole, setSelectedEcole] = useState("")


  const [editInitial, setEditInitial] = useState(null)
  const [editLoaded, setEditLoaded] = useState(false)

  const [optionHtml, setOptionHtml] = useState(null)
  const [disableAdd, setDisableAdd] = useState(true)

  const initFct = () => {
    if (isEdit && adminClient) {
      setName(adminClient?.name)
      setEmail(adminClient?.email)
      setLanguage(adminClient?.language)
      setSuivi(adminClient?.plan.suivi)
      setMapping(adminClient?.plan.mapping)
      setCertif(adminClient?.plan.certif)
      setActEcoles(adminClient?.ecoles)
      setEditInitial(adminClient)

      setEditLoaded(true)
    }
  }


  useEffect(() => {
    initFct()
  }, [isEdit, adminClient, editLoaded])

  useEffect(() => {
    if (isEdit === true && editLoaded === true) {
      if (
        name !== editInitial.name
        || email !== editInitial.email
        || language !== editInitial.language
        || suivi !== editInitial.plan.suivi
        || mapping !== editInitial.plan.mapping
        || certif !== editInitial.plan.certif
        || JSON.stringify(actEcoles) !== JSON.stringify(editInitial.ecoles)
      ) {
        setHasChanged(true)
      } else {
        setHasChanged(false)
      }
    }
    if (isEdit !== true) {
      if (name !== "" && email !== "" && isEmail(email) === true && language !== "") {
        setHasChanged(true)
      } else {
        setHasChanged(false)
      }
    }
  }, [isEdit, name, email, language, suivi, mapping, certif, actEcoles, editInitial, editLoaded])

  useEffect(() => {
    if (ecoles?.length > 0) {
      let count = 0;
      setOptionHtml(ecoles?.filter((e) => e.archived !== "true").map((ecl, index) => {
        let find = actEcoles?.find((el) => el.ecoleID === ecl.id)
        if (!find) {
          if (count === 0) {
            setSelectedEcole(ecl.id)
          }
          count++
          return (
            <option key={index + 'ecoleSelect'} value={ecl.id}>
              {ecl.name}
            </option>
          )
        }
      }))
      if (count === 0) {
        setDisableAdd(true)
      } else {
        setDisableAdd(false)
      }
    }
  }, [ecoles, editLoaded, editInitial, actEcoles])

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setHasChanged(false)
    if (isEdit) {
      let access = { suivi : suivi, mapping : mapping, certif : certif }
      //removedEcoles
      let removedEcoles = editInitial?.ecoles?.filter((el) => {
        return !actEcoles?.find((e) => e.ecoleID === el.ecoleID)
      })
      //addedEcoles
      let addedEcoles = actEcoles?.filter((el) => {
        return !editInitial?.ecoles?.find((g) => g.ecoleID === el.ecoleID)
      })
      let values = {id : parseInt(adminClient?.id), name : name, email : email.toLowerCase(), language : language, access : JSON.stringify(access), removedEcoles : removedEcoles, addedEcoles : addedEcoles}
      APIS.editAdminClient(values).then((result) => {
        if (result?.isOk === true) {
          updateAdminAdminClients()
          navigate('/admin/adminclient')
        } else if (result?.isOk === "emailerror") {
          alert("L'adresse email est déjà utilisée")
          setHasChanged(true)
        } else {
          alert("Erreur !")
          setHasChanged(true)
        }
      })
    } else {
      if (name !== "" && email !== "" && isEmail(email) === true && language !== "") {
        let access = { suivi : suivi, mapping : mapping, certif : certif }
        let values = {name : name, email : email.toLowerCase(), language : language, access : JSON.stringify(access), ecoles : actEcoles}
        APIS.addAdminClient(values).then((result) => {
          if (result?.isOk === true) {
            updateAdminAdminClients()
            navigate('/admin/adminclient')
          } else if (result?.isOk === "emailerror") {
            alert("L'adresse email est déjà utilisée")
            setHasChanged(true)
          } else {
            alert("Erreur !")
            setHasChanged(true)
          }
        })
      } else {
        alert ("Il y a un problème avec les informations renseignées")
      }
    }
  }

  return (
    <>
      <form noValidate onSubmit={onSubmitForm}>
        <Box sx={{ padding:"0px 10px" }}>
          <Box>
            <Box>Nom</Box>
            <input
              onChange={(e) => {setName(e.target.value)}}
              value={name}
              id="name"
              name="name"
              placeholder="Nawal Abboub"
              type="text"
              style={adminInputStyle}
            />
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>Email</Box>
            <input
              onChange={(e) => {setEmail(e.target.value)}}
              value={email}
              id="email"
              name="email"
              placeholder="email@risinguparis.com"
              type="text"
              style={adminInputStyle}
            />
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>Language</Box>
            <select
              onChange={(e) => {setLanguage(e.target.value)}}
              id="language"
              name="language"
              style={{width:'150px', marginTop:'10px',}}
              value={language}
            >
              <option value="fr">
                Français
              </option>
              <option value="en">
                English
              </option>
            </select>
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box sx={{marginBottom:"5px"}}>Accès</Box>
            <Box sx={{display:"flex", gap:"5px", marginLeft:"5px", marginBottom:"5px"}}>
              <input
                type="checkbox"
                id="acces_suivi" name="acces_suivi"
                style={{width:'unset', display:'unset'}}
                checked={suivi}
                onChange={(e) => {setSuivi(true)}}
              />
              <Box>Suivi</Box>
            </Box>
            <Box sx={{display:"flex", gap:"5px", marginLeft:"5px", marginBottom:"5px"}}>
              <input
                type="checkbox"
                id="acces_mapping" name="acces_mapping"
                style={{width:'unset', display:'unset'}}
                checked={mapping}
                onChange={(e) => {setMapping(e.target.checked)}}
              />
              <Box>Progression</Box>
            </Box>
            <Box sx={{display:"flex", gap:"5px", marginLeft:"5px"}}>
              <input
                type="checkbox"
                id="acces_certif" name="acces_certif"
                style={{width:'unset', display:'unset'}}
                checked={certif}
                onChange={(e) => {setCertif(e.target.checked)}}
              />
              <Box>Certification</Box>
            </Box>
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>École(s) actuelles</Box>
            <Box sx={{marginLeft:'5px'}}>
              {ecoles && actEcoles?.map((ecl, index) => {
                let find = ecoles?.find((el) => el.id === ecl.ecoleID)
                if (find) {
                  return (
                    <div key={"actEcole"+find.id} style={{display:"flex", alignItems:"center"}}>
                      {find.archived === "true" ? (
                        <p>- {find.name} (archivé)</p>
                      ) : (
                        <p>- {find.name}</p>
                      )}
                      <XCircleIcon
                        color="black"
                        size={14}
                        style={{marginLeft:"10px", cursor:"pointer"}}
                        onClick={() => {
                          setActEcoles(
                            actEcoles.filter(el =>
                              el.ecoleID !== find.id
                            )
                          );
                        }}
                      />
                    </div>
                  )
                }
              })}
            </Box>
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>Ajouter école</Box>
            <Box sx={{marginTop:'10px', display:'flex'}}>
              <select
                onChange={(e) => { setSelectedEcole(e.target.value) }}
                id="ecoles"
                name="ecoles"
                style={{width:'307px'}}
                value={selectedEcole}
                disabled={disableAdd}
              >
                {optionHtml}
              </select>
              <PlusCircleIcon
                color="black"
                size={19}
                style={{marginLeft:"15px", cursor:"pointer", opacity: disableAdd === true ? 0.4 : 1}}
                onClick={() => {
                  if (disableAdd !== true) {
                    setActEcoles([...actEcoles, {ecoleID : parseInt(selectedEcole)}])
                  }
                }}
              />
            </Box>
          </Box>

          <button hidden type="submit" id="hidden_form_submit">
            Action
          </button>
        </Box>
      </form>
    </>
  )
};

export default AdminClientForm;
